export const environment = {
  production: true,
  app: 'admin',
  marketplaceApiUrl: 'https://api-dev-marketplace.shabic.com',
  clientApiUrl: 'https://api-dev-client.shabic.com',
  productbankApiUrl: 'https://api-dev-productbank.shabic.com'
};
